import AirbnbIcon from 'assets/images/icons/channels/airbnb.svg?react';
import BookingIcon from 'assets/images/icons/channels/booking.svg?react';
import GoogleIcon from 'assets/images/icons/channels/google.svg?react';
import HomeToGoIcon from 'assets/images/icons/channels/hometogo.svg?react';
import HostfullyIcon from 'assets/images/icons/channels/hostfully.svg?react';
import HvmiIcon from 'assets/images/icons/channels/hvmi.svg?react';
import TripAdvisorIcon from 'assets/images/icons/channels/tripadvisor.svg?react';
import VrboIcon from 'assets/images/icons/channels/vrbo.svg?react';
import GolightlyIcon from 'assets/images/icons/channels/golightly.svg?react';
import HomadsIcon from 'assets/images/icons/channels/homads.svg?react';
import VacayMyWayIcon from 'assets/images/icons/channels/vacaymyway.svg?react';

import { Channel } from 'models/Channels';
import { IntegrationEnum } from 'models/InternalIntegrationSetting';

export const channelsToShow = [
  Channel.airbnb,
  Channel.orbirental,
  Channel.booking_com,
  Channel.homeaway,
  Channel.google,
  Channel.hvmi,
  Channel.tripadvisor,
  Channel.hometogo,
  Channel.golightly,
  Channel.vacaymyway,
  Channel.homads,
];

const v3DetailsPath = (enumId: IntegrationEnum) =>
  `#/channels/details/${enumId}`;

export const ChannelProps = {
  [Channel.airbnb]: {
    enumId: Channel.airbnb,
    name: 'Airbnb',
    Icon: AirbnbIcon,
    getPropertyChannelLink: () => '#/channels/airbnb/sync',
    isPropertyLinkEditable: false,
  },
  [Channel.booking_com]: {
    enumId: Channel.booking_com,
    name: 'Booking.com',
    Icon: BookingIcon,
    getPropertyChannelLink: () => '#/channels/bookingdotcom/sync',
    isPropertyLinkEditable: true,
  },
  [Channel.golightly]: {
    enumId: Channel.golightly,
    name: 'Golightly',
    Icon: GolightlyIcon,
    getPropertyChannelLink: (allowChannelsV3: boolean) =>
      allowChannelsV3
        ? v3DetailsPath(IntegrationEnum.GOLIGHTLY)
        : '#/channels/default/sync?chname=Golightly',
    isPropertyLinkEditable: false,
  },
  [Channel.google]: {
    enumId: Channel.google,
    name: 'Google',
    Icon: GoogleIcon,
    getPropertyChannelLink: (allowChannelsV3: boolean) =>
      allowChannelsV3
        ? v3DetailsPath(IntegrationEnum.GOOGLE)
        : '#/channels/default/sync?chname=Google',
    isPropertyLinkEditable: true,
  },
  [Channel.homads]: {
    enumId: Channel.homads,
    name: 'Homads',
    Icon: HomadsIcon,
    getPropertyChannelLink: (allowChannelsV3: boolean) =>
      allowChannelsV3
        ? v3DetailsPath(IntegrationEnum.HOMADS)
        : '#/channels/default/sync?chname=Homads',
    isPropertyLinkEditable: false,
  },
  [Channel.homeaway]: {
    enumId: Channel.homeaway,
    name: 'Vrbo',
    Icon: VrboIcon,
    getPropertyChannelLink: () => '#/channels/vrbo/sync',
    isPropertyLinkEditable: false,
  },
  [Channel.hometogo]: {
    enumId: Channel.hometogo,
    name: 'HomeToGo',
    Icon: HomeToGoIcon,
    getPropertyChannelLink: (allowChannelsV3: boolean) =>
      allowChannelsV3
        ? v3DetailsPath(IntegrationEnum.HOMETOGO)
        : '#/channels/default/sync?chname=Hometogo',
    isPropertyLinkEditable: false,
  },
  [Channel.hvmi]: {
    enumId: Channel.hvmi,
    name: 'HVMI',
    Icon: HvmiIcon,
    getPropertyChannelLink: () => '#/channels/default/sync?chname=HVMB',
    isPropertyLinkEditable: false,
  },
  [Channel.orbirental]: {
    enumId: Channel.orbirental,
    name: 'Hostfully',
    Icon: HostfullyIcon,
    getPropertyChannelLink: (allowChannelsV3: boolean) =>
      allowChannelsV3
        ? v3DetailsPath(IntegrationEnum.ORBIRENTAL)
        : '#/channels/default/sync?chname=Orbirental',
    isPropertyLinkEditable: false,
  },
  [Channel.tripadvisor]: {
    enumId: Channel.tripadvisor,
    name: 'TripAdvisor',
    Icon: TripAdvisorIcon,
    getPropertyChannelLink: (allowChannelsV3: boolean) =>
      allowChannelsV3
        ? v3DetailsPath(IntegrationEnum.TRIPADVISOR)
        : '#/channels/default/sync?chname=TripAdvisor',
    isPropertyLinkEditable: true,
  },
  [Channel.vacaymyway]: {
    enumId: Channel.vacaymyway,
    name: 'VacayMyWay',
    Icon: VacayMyWayIcon,
    getPropertyChannelLink: (allowChannelsV3: boolean) =>
      allowChannelsV3
        ? v3DetailsPath(IntegrationEnum.VACAYMYWAY)
        : '#/channels/default/sync?chname=VacayMyWay',
    isPropertyLinkEditable: false,
  },
};

export const editExternalLinkModalId =
  'property-channel-edit-external-link-modal';
